import React from "react";
import { ListBuilder, Table } from "@redriver/cinnamon";
import { getPassengersList } from "./actions";
import { ContentPanel } from "components/containers";

const PassengerInfoPanel = ({ bookingId }) => {
  return (
    <ContentPanel title="Passenger Info">
      <ListBuilder
        withTable
        loadAction={getPassengersList}
        loadParams={{ bookingId }}
        loadTransform={(data) => data.passengers}
        renderList={(tableProps) => (
          <Table {...tableProps} unstackable>
            <Table.Column field="typeName" title="Type" />
            <Table.Column
              render={(item) =>
                `${item.title ? item.title + " " : ""} ${item.firstName} ${
                  item.lastName
                }`
              }
              title="Name"
            />
            <Table.Column field="genderName" title="Gender" />
          </Table>
        )}
      />
    </ContentPanel>
  );
};

export default PassengerInfoPanel;
